import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue'),
        meta: { title: '登录', noTab: true, noAuth: true }
    },
    {
        // path: '/redirect/:path(.*)',
        path: '/redirect',
        name: 'redirect',
        // component: () => import('../views/Redirect.vue'),
        component: () => import('../views/RefreshView.vue'),
        meta: { hidden: true, noTab: true, noAuth: true }
    },
    {
        path: '/goodsDetail',
        name: 'goodsDetail',
        component: () => import('../views/GoodsDetail.vue'),
        meta: { title: '货品详情', noTab: true, noAuth: true }  // noAuth: true 允许未登录访问
    },
    {
        path: '/layout',
        name: 'layout',
        component: () => import('../components/Layout.vue'),
        meta: { requireAuth: true },
        children: [
            // 首页
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('../views/Dashboard.vue'),
                meta: { title: '首页', requireAuth: true, keepAlive: true }
            },

            // 用户管理相关
            {
                path: '/user',
                name: 'user',
                component: () => import('../views/User.vue'),
                meta: { title: '用户管理', requireAuth: true, permissionCode: 'MANAGE_USER' }
            },
            {
                path: '/permission',
                name: 'permission',
                component: () => import('../views/Permission.vue'),
                meta: { title: '权限管理', requireAuth: true, permissionCode: 'MANAGE_PERMISSION' }
            },
            {
                path: '/role',
                name: 'role',
                component: () => import('../views/Role.vue'),
                meta: { title: '角色管理', requireAuth: true, permissionCode: 'MANAGE_ROLE' }
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('../views/Profile.vue'),
                meta: { title: '个人中心', requireAuth: true }
            },
            {
                path: '/changePassword',
                name: 'changePassword',
                component: () => import('../views/ChangePassword.vue'),
                meta: { title: '修改密码', requireAuth: true }
            },

            // 业务系统
            {
                path: '/procurement',
                name: 'procurement',
                component: () => import('../views/Procurement.vue'),
                meta: { title: '采购管理', requireAuth: true }
            },
            {
                path: '/requisition',
                name: 'requisition',
                component: () => import('../views/Requisition.vue'),
                meta: { title: '采购申请', requireAuth: true, keepAlive: true }
            },
            {
                path: '/purchaseOrder',
                name: 'purchaseOrder',
                component: () => import('../views/PurchaseOrder.vue'),
                meta: { title: '采购订单', requireAuth: true , keepAlive: true}
            },
            {
                path: '/purchaseBilling',
                name: 'purchaseBilling',
                component: () => import('../views/PurchaseBilling.vue'),
                meta: { title: '采购开单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/procurementCostAllocation',
                name: 'procurementCostAllocation',
                component: () => import('../views/ProcurementCostAllocation.vue'),
                meta: { title: '采购费用分摊', requireAuth: true,keepAlive: true }
            },

            // 销售系统
            {
                path: '/sales',
                name: 'sales',
                component: () => import('../views/Sales.vue'),
                meta: { title: '销售管理', requireAuth: true }
            },
            {
                path: '/salesOrder',
                name: 'salesOrder',
                component: () => import('../views/SalesOrder.vue'),
                meta: { title: '销售订单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/productQuotation',
                name: 'productQuotation',
                component: () => import('../views/ProductQuotation.vue'),
                meta: { title: '产品报价', requireAuth: true,keepAlive: true }
            },
            {
                path: '/salesBilling',
                name: 'salesBilling',
                component: () => import('../views/SalesBilling.vue'),
                meta: { title: '销售开单', requireAuth: true ,keepAlive: true}
            },

            // 仓库系统
            {
                path: '/warehouse',
                name: 'warehouse',
                component: () => import('../views/Warehouse.vue'),
                meta: { title: '仓库管理', requireAuth: true,keepAlive: true }
            },
            {
                path: '/production',
                name: 'production',
                component: () => import('../views/Production.vue'),
                meta: { title: '生产管理', requireAuth: true,keepAlive: true }
            },
            {
                path: '/production/bom',
                name: 'productionBom',
                component: () => import('../views/Bom.vue'),
                meta: { title: '物料清单', requireAuth: true, keepAlive: true }
            },
            {
                path: '/production/mps',
                name: 'mps',
                component: () => import('../views/MPS.vue'),
                meta: { title: '主生产计划', requireAuth: true, keepAlive: true }
            },
            {
                path: '/production/costing',
                name: 'costing',
                component: () => import('../views/Costing.vue'),
                meta: { title: '成本计算表', requireAuth: true, keepAlive: true }
            },
            {
                path: '/inventoryList',
                name: 'inventoryList',
                component: () => import('../views/InventoryList.vue'),
                meta: { title: '盘点单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/warehouseInOut',
                name: 'warehouseInOut',
                component: () => import('../views/WarehouseInOut.vue'),
                meta: { title: '出入库单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/materialRequest',
                name: 'materialRequest',
                component: () => import('../views/MaterialRequest.vue'),
                meta: { title: '领料单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/assemblyOrder',
                name: 'assemblyOrder',
                component: () => import('../views/AssemblyOrder.vue'),
                meta: { title: '组装单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/disassemblyOrder',
                name: 'disassemblyOrder',
                component: () => import('../views/DisassemblyOrder.vue'),
                meta: { title: '拆卸单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/damageReport',
                name: 'damageReport',
                component: () => import('../views/DamageReport.vue'),
                meta: { title: '破损单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/otherShipping',
                name: 'otherShipping',
                component: () => import('../views/OtherShipping.vue'),
                meta: { title: '其他出库', requireAuth: true,keepAlive: true }
            },
            {
                path: '/otherReceiving',
                name: 'otherReceiving',
                component: () => import('../views/OtherReceiving.vue'),
                meta: { title: '其他入库', requireAuth: true,keepAlive: true }
            },
            {
                path: '/workOrder',
                name: 'workOrder',
                component: () => import('../views/WorkOrder.vue'),
                meta: { title: '加工单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/estimatedStock',
                name: 'estimatedStock',
                component: () => import('../views/EstimatedStock.vue'),
                meta: { title: '预估库存', requireAuth: true,keepAlive: true }
            },

            // 资金系统
            {
                path: '/accountsReceivableAndPayable',
                name: 'accountsReceivableAndPayable',
                component: () => import('../views/AccountsReceivableAndPayable.vue'),
                meta: { title: '应收应付管理', requireAuth: true,keepAlive: true }
            },
            {
                path: '/cashBank',
                name: 'cashBank',
                component: () => import('../views/CashBank.vue'),
                meta: { title: '现金银行管理', requireAuth: true,keepAlive: true }
            },
            {
                path: '/receipt',
                name: 'receipt',
                component: () => import('../views/Receipt.vue'),
                meta: { title: '收款单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/paymentSlip',
                name: 'paymentSlip',
                component: () => import('../views/PaymentSlip.vue'),
                meta: { title: '付款单', requireAuth: true,keepAlive: true }
            },
            {
                path: '/expensePayment',
                name: 'expensePayment',
                component: () => import('../views/ExpensePayment.vue'),
                meta: { title: '费用付款', requireAuth: true,keepAlive: true }
            },
            {
                path: '/costAllocation',
                name: 'costAllocation',
                component: () => import('../views/CostAllocation.vue'),
                meta: { title: '费用分摊', requireAuth: true ,keepAlive: true}
            },

            // 货品管理
            {
                path: '/goodsList',
                name: 'goodsList',
                component: () => import('../views/GoodsList.vue'),
                meta: { title: '货品列表', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/stockShortage',
                name: 'stockShortage',
                component: () => import('../views/StockShortage.vue'),
                meta: { title: '库存不足看板', requireAuth: true, keepAlive: true, permissionCode: 'STOCK_SHORTAGE_VIEW' }
            },

            // 系统设置
            {
                path: '/organizationManagement',
                name: 'organizationManagement',
                component: () => import('../views/OrganizationManagement.vue'),
                meta: { title: '组织管理', requireAuth: true }
            },
            {
                path: '/subjectManagement',
                name: 'subjectManagement',
                component: () => import('../views/SubjectManagement.vue'),
                meta: { title: '科目管理', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/cashierAccount',
                name: 'cashierAccount',
                component: () => import('../views/CashierAccount.vue'),
                meta: { title: '出纳账户', requireAuth: true ,keepAlive: true}
            },

            // 报表分析
            {
                path: '/report',
                name: 'report',
                component: () => import('../views/Report.vue'),
                meta: { title: '采购报表', requireAuth: true }
            },
            // {
            //     path: '/reportSales',
            //     name: 'reportSales',
            //     component: () => import('../views/ReportSales.vue'),
            //     meta: { title: '销售报表ori', requireAuth: true }
            // },
            {
                path: '/warehouseReport',
                name: 'warehouseReport',
                component: () => import('../views/WarehouseReport.vue'),
                meta: { title: '仓库报表', requireAuth: true }
            },
            {
                path: '/receivables',
                name: 'ReceivablesDashboard',
                component: () => import('../views/ReceivablesDashboard.vue'),
                meta: { title: '销售报表', requireAuth: true}
            },

            // 全息看板
            {
                path: '/openingData',
                name: 'openingData',
                component: () => import('../views/OpeningData.vue'),
                meta: { title: '期初数据', requireAuth: true }
            },
            {
                path: '/transactionDetails',
                name: 'transactionDetails',
                component: () => import('../views/TransactionDetails.vue'),
                meta: { title: '流水明细', requireAuth: true }
            },

            // OA流程
            {
                path: '/employeeApplication',
                name: 'employeeApplication',
                component: () => import('../views/EmployeeApplication.vue'),
                meta: { title: '员工申请', requireAuth: true,keepAlive: true }
            },
            {
                path: '/applicationHrBusinessTrip',
                name: 'applicationHrBusinessTrip',
                component: () => import('../views/ApplicationHrBusinessTrip.vue'),
                meta: { title: 'HR出差申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationHrLeave',
                name: 'applicationHrLeave',
                component: () => import('../views/ApplicationHrLeave.vue'),
                meta: { title: 'HR请假申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationHrGoOut',
                name: 'applicationHrGoOut',
                component: () => import('../views/ApplicationHrGoOut.vue'),
                meta: { title: 'HR外出申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationHrOvertime',
                name: 'applicationHrOvertime',
                component: () => import('../views/ApplicationHrOvertime.vue'),
                meta: { title: 'HR加班申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationHrRegularization',
                name: 'applicationHrRegularization',
                component: () => import('../views/ApplicationHrRegularization.vue'),
                meta: { title: 'HR转正申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalAdmin',
                name: 'approvalAdmin',
                component: () => import('../views/ApprovalAdmin.vue'),
                meta: { title: '审批管理', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalHrBusinessTrip',
                name: 'approvalHrBusinessTrip',
                component: () => import('../views/ApprovalHrBusinessTrip.vue'),
                meta: { title: 'HR出差审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalHrGoOut',
                name: 'approvalHrGoOut',
                component: () => import('../views/ApprovalHrGoOut.vue'),
                meta: { title: 'HR外出审批', requireAuth: true,keepAlive: true }
            },
            {
                path: '/approvalHrLeave',
                name: 'approvalHrLeave',
                component: () => import('../views/ApprovalHrLeave.vue'),
                meta: { title: 'HR请假审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalHrOvertime',
                name: 'approvalHrOvertime',
                component: () => import('../views/ApprovalHrOvertime.vue'),
                meta: { title: 'HR加班审批', requireAuth: true,keepAlive: true }
            },
            {
                path: '/approvalHrRegularization',
                name: 'approvalHrRegularization',
                component: () => import('../views/ApprovalHrRegularization.vue'),
                meta: { title: 'HR转正审批', requireAuth: true,keepAlive: true }
            },
            {
                path: '/applicationAdminSealBorrow',
                name: 'applicationAdminSealBorrow',
                component: () => import('../views/ApplicationAdminSealBorrow.vue'),
                meta: { title: '印章借用申请', requireAuth: true,keepAlive: true }
            },
            {
                path: '/approvalAdminSealBorrow',
                name: 'approvalAdminSealBorrow',
                component: () => import('../views/ApprovalAdminSealBorrow.vue'),
                meta: { title: '印章借用审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationAdminForeignSeal',
                name: 'applicationAdminForeignSeal',
                component: () => import('../views/ApplicationAdminForeignSeal.vue'),
                meta: { title: '外印申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalAdminForeignSeal',
                name: 'approvalAdminForeignSeal',
                component: () => import('../views/ApprovalAdminForeignSeal.vue'),
                meta: { title: '外印审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationAdminForeignContractSeal',
                name: 'applicationAdminForeignContractSeal',
                component: () => import('../views/ApplicationAdminForeignContractSeal.vue'),
                meta: { title: '外印合同申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalAdminForeignContractSeal',
                name: 'approvalAdminForeignContractSeal',
                component: () => import('../views/ApprovalAdminForeignContractSeal.vue'),
                meta: { title: '外印合同审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationAdminContractSeal',
                name: 'applicationAdminContractSeal',
                component: () => import('../views/ApplicationAdminContractSeal.vue'),
                meta: { title: '合同申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalAdminContractSeal',
                name: 'approvalAdminContractSeal',
                component: () => import('../views/ApprovalAdminContractSeal.vue'),
                meta: { title: '合同审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationFinanceInvoice',
                name: 'applicationFinanceInvoice',
                component: () => import('../views/ApplicationFinanceInvoice.vue'),
                meta: { title: '发票申请', requireAuth: true,keepAlive: true }
            },
            {
                path: '/approvalFinanceInvoice',
                name: 'approvalFinanceInvoice',
                component: () => import('../views/ApprovalFinanceInvoice.vue'),
                meta: { title: '发票审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationFinanceLoan',
                name: 'applicationFinanceLoan',
                component: () => import('../views/ApplicationFinanceLoan.vue'),
                meta: { title: '借款申请', requireAuth: true,keepAlive: true }
            },
            {
                path: '/approvalFinanceLoan',
                name: 'approvalFinanceLoan',
                component: () => import('../views/ApprovalFinanceLoan.vue'),
                meta: { title: '借款审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationFinanceReimburse',
                name: 'applicationFinanceReimburse',
                component: () => import('../views/ApplicationFinanceReimburse.vue'),
                meta: { title: '报销申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalFinanceReimburse',
                name: 'approvalFinanceReimburse',
                component: () => import('../views/ApprovalFinanceReimburse.vue'),
                meta: { title: '报销审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/applicationFinancePayment',
                name: 'applicationFinancePayment',
                component: () => import('../views/ApplicationFinancePayment.vue'),
                meta: { title: '付款申请', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/approvalFinancePayment',
                name: 'approvalFinancePayment',
                component: () => import('../views/ApprovalFinancePayment.vue'),
                meta: { title: '付款审批', requireAuth: true ,keepAlive: true}
            },
            {
                path: '/commonCcRecords',
                name: 'commonCcRecords',
                component: () => import('../views/CommonCcRecords.vue'),
                meta: { title: '抄送记录', requireAuth: true ,keepAlive: true}
            },

            // 基础资料
            {
                path: '/supplier',
                name: 'supplier',
                component: () => import('../views/Supplier.vue'),
                meta: { title: '供应商管理', requireAuth: true,keepAlive: true }
            },
            {
                path: '/customer',
                name: 'customer',
                component: () => import('../views/Customer.vue'),
                meta: { title: '客户管理', requireAuth: true ,keepAlive: true}
            },

        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

import store from '@/store'
import {ElMessage} from "element-plus";

router.beforeEach(async (to, from, next) => {
    if (to.meta.noAuth) {
        next()
        return
    }
    const userInfoStr = localStorage.getItem('userInfo')
    if (!userInfoStr) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
        return
    }

    try {
        const userInfo = JSON.parse(userInfoStr)
        if (userInfo.expireTime && Date.now() > userInfo.expireTime) {
            // 过期了，清除数据并跳转登录
            localStorage.removeItem('userInfo')
            localStorage.removeItem('userPermissions')
            ElMessage.warning('登录已过期，请重新登录')
            next({ path: '/login', query: { redirect: to.fullPath } })
            return
        }
    } catch (e) {
        // 解析失败或过期处理异常
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userPermissions')
        ElMessage.warning('登录信息异常，请重新登录')
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
    }

    try {
        const userInfo = JSON.parse(userInfoStr)
        if (!userInfo.id || !userInfo.username) {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('userPermissions')
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
            return
        }
        if (!store.getters.isLoggedIn) {
            store.commit('SET_USER_INFO', userInfo)
        }

    } catch (error) {
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userPermissions')
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
        return
    }
    if (to.meta.permissionCode) {
        const permissionsStr = localStorage.getItem('userPermissions')
        let userPermissions = []
        if (permissionsStr) {
            userPermissions = JSON.parse(permissionsStr)
        }
        if (userPermissions.length === 0 && store.state.user.permissions) {
            userPermissions = store.state.user.permissions
        }
        const hasPerm = userPermissions.includes(to.meta.permissionCode)
        if (!hasPerm) {
            ElMessage.warning('权限不足，无法访问该页面')
            if (to.path !== '/dashboard') {
                next('/dashboard')
            } else {
                next()
            }
            return
        }
    }
    if (!to.meta.noTab && to.meta.title && to.name && to.path !== '/login') {
        store.dispatch('addTab', {
            path: to.path,
            name: to.name,
            meta: to.meta
        })
    }
    next()
})

export default router
